(() => {
  const KEY = 'nubs-site-search-mode-v1';
  const normalize = (value) => value === 'database' ? 'database' : value === 'store' ? 'store' : null;

  function savedMode() {
    try { return normalize(localStorage.getItem(KEY)); }
    catch (_) { return null; }
  }

  function contextualMode(form) {
    return normalize(form?.dataset.defaultSearchMode) || 'store';
  }

  function paint(selected, form, mode, input) {
    if (!selected || !form || !mode || !input) return;
    mode.value = selected;
    document.documentElement.dataset.nubsSearchMode = selected;
    input.placeholder = selected === 'database'
      ? 'Search database titles, publishers, UPCs...'
      : 'Search titles, studios, publishers, UPCs...';
    input.setAttribute('aria-label', selected === 'database' ? 'Search database' : "Search Nub's Media shop");
    form.classList.add('is-mode-ready');
    form.hidden = false;
  }

  function apply() {
    const mode = document.querySelector('[data-site-search-mode]');
    const input = document.querySelector('[data-site-search-input]');
    const form = document.querySelector('[data-site-search]');
    if (!mode || !input || !form) return false;

    // A shopper's explicit choice wins permanently until they change it.
    // Otherwise follow the current storefront surface.
    paint(savedMode() || contextualMode(form), form, mode, input);

    if (!mode.dataset.nubsSearchModeBound) {
      mode.dataset.nubsSearchModeBound = 'true';
      mode.addEventListener('change', () => {
        const next = normalize(mode.value);
        if (!next) return;
        paint(next, form, mode, input);
        try { localStorage.setItem(KEY, next); } catch (_) {}
      });
    }
    return true;
  }

  if (!apply()) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, {once:true});
    else apply();
  }

  // Soft navigation keeps the header in place. If the shopper has never made
  // an explicit choice, repaint the selector when the page surface changes.
  document.addEventListener('nubs:surfacechange', () => {
    if (savedMode()) return;
    const form = document.querySelector('[data-site-search]');
    const mode = document.querySelector('[data-site-search-mode]');
    const input = document.querySelector('[data-site-search-input]');
    if (!form || !mode || !input) return;
    paint(contextualMode(form), form, mode, input);
  });
})();
